// Product feature switches for Qayd. Turning a feature off hides it from navigation and
// entry points; the code stays in place so it can be switched back on.
export const FEATURES = {
  export: false, // Export & Export Finance (vehicles/containers export business)
  // n8n chatbot inherited from Galaxy: loads its webhook URL from a personal GitHub repo / Google Doc
  // via corsproxy.io and sends the signed-in user's email there. Off until Qayd has its own assistant.
  chatbot: false,
};

/** True for menu items that belong to the Export feature ("Export", "Export Finance", "Export Customers", ...). */
export const isExportItem = (name = "") => /^export\b/i.test(String(name).trim());

/** Filters a navigation list (and its children) by the enabled features. */
export function filterNavByFeatures(items = []) {
  if (FEATURES.export) return items;
  return items
    .filter((item) => !isExportItem(item?.name))
    .map((item) => (item?.children ? { ...item, children: item.children.filter((c) => !isExportItem(c?.name)) } : item));
}
